// Guards against a tap on the search suggestion list "falling through" to the
// map. ANDROID: tapping a suggestion unmounts the list mid-touch, and Chrome
// then retargets the leftover synthesized click to whatever is now under the
// finger — the map canvas. MapCanvas' click handler would immediately run
// selectRoad(null) + dismissSearch(), undoing the pick the user just made
// (iOS never retargets, so only Android showed the bug). While the window is
// active, MapCanvas ignores map clicks entirely.
let suppressUntil = 0

export const suppressNextMapClick = (ms = 900) => {
  suppressUntil = Math.max(suppressUntil, Date.now() + ms)
}

export const isMapClickSuppressed = () => Date.now() < suppressUntil
